/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlBulkReportAssetsItem } from './ControlBulkReportAssetsItem';
import {
    ControlBulkReportAssetsItemFromJSON,
    ControlBulkReportAssetsItemFromJSONTyped,
    ControlBulkReportAssetsItemToJSON,
} from './ControlBulkReportAssetsItem';

/**
 * 
 * @export
 * @interface ControlBulkReportAssetsBody
 */
export interface ControlBulkReportAssetsBody {
    /**
     * 
     * @type {Array<ControlBulkReportAssetsItem>}
     * @memberof ControlBulkReportAssetsBody
     */
    items: Array<ControlBulkReportAssetsItem>;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsBody
     */
    external_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsBody
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlBulkReportAssetsBody
     */
    reviewed_by: string;
}

/**
 * Check if a given object implements the ControlBulkReportAssetsBody interface.
 */
export function instanceOfControlBulkReportAssetsBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "external_id" in value;
    isInstance = isInstance && "reviewed_by" in value;

    return isInstance;
}

export function ControlBulkReportAssetsBodyFromJSON(json: any): ControlBulkReportAssetsBody {
    return ControlBulkReportAssetsBodyFromJSONTyped(json, false);
}

export function ControlBulkReportAssetsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkReportAssetsBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ControlBulkReportAssetsItemFromJSON)),
        'external_id': json['external_id'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'reviewed_by': json['reviewed_by'],
    };
}

export function ControlBulkReportAssetsBodyToJSON(value?: ControlBulkReportAssetsBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ControlBulkReportAssetsItemToJSON)),
        'external_id': value.external_id,
        'reason': value.reason,
        'reviewed_by': value.reviewed_by,
    };
}

